<template>
  <div>
    <div class="card shadow-sm border-0">
      <div class="card-header bg-white">
        <div class="d-flex justify-content-between align-items-center">
          <h5>Subcategorías</h5>
          <AddSubCategory @refresh="getSubCategories" />
        </div>
      </div>
      <div class="card-body">
        <div v-if="!loading" class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th class="col-drag"><i class="fas fa-arrows-alt-v"></i></th>
                <th class="col-pos">Pos.</th>
                <th>Subcategoría</th>
                <th>Categoría</th>
                <th>Temática</th>
                <th class="col-status text-center">Estado</th>
                <th class="col-actions text-center">Acciones</th>
              </tr>
            </thead>
            <draggable
              v-if="subcategories.length"
              v-model="subcategories"
              group="subcategories"
              item-key="UUID"
              handle=".drag-handle"
              @end="updateOrder"
              tag="tbody"
            >
              <template #item="{ element, index }">
                <SubCategoryRow 
                  :subcategory="element" 
                  :topics="topics" 
                  :position="(serverOptions.page - 1) * serverOptions.rowsPerPage + (index + 1)" 
                />
              </template>
            </draggable>
            <tbody v-else>
              <tr>
                <td colspan="7" class="text-center text-muted py-4">No hay subcategorías disponibles.</td>
              </tr>
            </tbody>
          </table>

          <div class="d-flex flex-wrap justify-content-between align-items-center mt-3">
            <div class="text-muted small">
              Mostrando 
              {{ (serverOptions.page - 1) * serverOptions.rowsPerPage + 1 }} - 
              {{ Math.min(serverOptions.page * serverOptions.rowsPerPage, serverItemsLength) }} 
              de {{ serverItemsLength }} resultados
            </div>
            <div class="d-flex align-items-center gap-3 small">
              <span>Líneas por página:</span>
              <select v-model.number="serverOptions.rowsPerPage" @change="updateRowsPerPage" class="form-select form-select-sm w-auto">
                <option v-for="n in [10, 25, 50]" :key="n" :value="n">{{ n }}</option>
              </select>
              <button class="btn btn-sm btn-light" :disabled="serverOptions.page === 1" @click="changePage(serverOptions.page - 1)">
                <i class="fa fa-chevron-left"></i>
              </button>
              <button class="btn btn-sm btn-light" :disabled="serverOptions.page * serverOptions.rowsPerPage >= serverItemsLength" @click="changePage(serverOptions.page + 1)">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div v-else class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="mt-2">Cargando información</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddSubCategory from "@/components/Blog/elements/SubCategories/AddSubCategory.vue";
import SubCategoryRow from "@/components/Blog/elements/SubCategories/SubCategoryRow.vue";
import SubCategoryService from "@/services/subcategory.service.js";
import TopicService from "@/services/topic.service";
import draggable from "vuedraggable";
import Swal from "sweetalert2";

export default {
  name: "SubCategories",
  components: {
    AddSubCategory,
    SubCategoryRow,
    draggable,
  },
  data() {
    return {
      subcategories: [],
      topics: [],
      loading: true,
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 10,
      },
    };
  },
  methods: {
    async start() {
      this.loading = true;
      await this.getTopics();
      await this.getSubCategories();
      this.loading = false;
    },
    async getSubCategories() {
      const params = {
        page: this.serverOptions.page,
        page_size: this.serverOptions.rowsPerPage
      };
      const response = await SubCategoryService.getAllSubCategories(params);
      
      // Adapt logic for hybrid response
      if (response.data.items) {
          this.subcategories = response.data.items;
          this.serverItemsLength = response.data.serverItemsLength;
      } else {
          this.subcategories = response.data;
          this.serverItemsLength = response.data.length;
      }
    },
    async getTopics() {
      const response = await TopicService.getAllTopics();
      this.topics = response.data;
    },
    async changePage(newPage) {
      this.loading = true;
      this.serverOptions.page = newPage;
      await this.getSubCategories();
      this.loading = false;
    },
    async updateRowsPerPage() {
      this.loading = true;
      this.serverOptions.page = 1;
      await this.getSubCategories();
      this.loading = false;
    },
    async updateOrder() {
      const offset = (this.serverOptions.page - 1) * this.serverOptions.rowsPerPage;
      try {
        Swal.fire({
          title: "Guardando orden...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        const updatedItems = this.subcategories.map((s, i) => ({
          UUID: s.UUID,
          position: offset + i + 1,
        }));

        await SubCategoryService.updateSubcategoriesOrder(updatedItems);

        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Orden actualizado",
          toast: true,
          position: "top-end",
          timer: 2000,
          showConfirmButton: false
        });
      } catch (error) {
        Swal.close();
        Swal.fire({ icon: "error", title: "Error al actualizar orden" });
      }
    },
  },
  created() {
    this.start();
  }
};
</script>

<style scoped>
.table-striped {
  table-layout: fixed;
  width: 100%;
}
.col-drag { width: 40px; text-align: center; }
.col-pos { width: 55px; text-align: center; }
.col-status { width: 85px; }
.col-actions { width: 95px; }
th { font-size: 0.85rem; vertical-align: middle; }
</style>